import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import Header from './Headers';
import MetaTags from 'react-meta-tags';
import ReactGA from 'react-ga';

@inject('store')
@observer
class ISpolicystatement extends Component {

    componentDidMount() {
        this.initializeReactGA();
        window.scrollTo(0, 0);
        this.props.store.homeType(false);
    }

    initializeReactGA() {
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/privacy_and_policy');
    }

    render() {
        return (
            <div>
                <MetaTags>
                    <title>Information Security Policy</title>
                    <meta name="description" content="Some description."/>
                    <meta property="og:title" content="MyApp"/>
                    <meta property="og:image" content="path/to/image.jpg"/>
                </MetaTags>
                <Header/>
                <section className="banner_text headerbg">
                    <div className="container">
                        <div className="aboutusbanner full-w text-center ">
                            <h1 className="full-w tex-center whitecolor fz-20">Information Security Policy</h1>
                        </div>
                    </div>
                </section>

                <section className="pdtb-20">
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <h3 className="fz-20">INFORMATION SECURITY POLICY STATEMENT</h3>
                                <br/>
                                <p>Revfin Services Private Limited (Revfin) is a financial technology (FinTech) company.
                                    Our advanced digital lending platform makes getting a loan convenient and accessible
                                    for our customers.</p>
                                <p>The objective of this Information Security Policy Statement is to ensure that Revfin
                                    Services Private Limited (Revfin) delivers a consistently high level of information
                                    security throughout the company. Revfin is committed to implementing and maintaining
                                    compliance with ISO 27001, and to continuous, practical improvement of our
                                    information security practices. This will help maintain our reputation in the
                                    industry and meet our legal/regulatory and customers’ requirements.</p>
                                <p>Revfin commits to:</p>
                                <p>
                                    <ul>
                                        <li className="listitem"> Clearly understanding the requirements and
                                            expectations of our customers and relevant regulatory authorities.
                                        </li>
                                        <li className="listitem"> Working closely with our customers and suppliers to
                                            deliver services in a security conscious fashion.
                                        </li>
                                        <li className="listitem"> Ensuring every employee shares responsibility for
                                            effective information security.
                                        </li>
                                        <li className="listitem"> Protecting its people, information, intellectual
                                            property, assets, activities and facilities against misuse, loss, damage,
                                            disruption, interference, espionage, or unauthorised disclosure. It is also
                                            critical that we retain the confidence of those who entrust sensitive
                                            information to Revfin.
                                        </li>
                                        <li className="listitem"> Developing and maintaining security policies and
                                            controls designed to meet the requirements of ISO 27001. The policy
                                            statements contained in our Information Security Policy (ISP), procedures,
                                            guidelines, and standards, reflect the minimum requirements necessary to
                                            maintain an acceptable standard for protecting our information assets and,
                                            at the same time, our reputation.
                                        </li>
                                        <li className="listitem"> The “Maker-Checker” principle for reducing the risk of
                                            error and misuse and to ensure reliability of data / information to the
                                            customers.
                                        </li>
                                        <li className="listitem">Periodic testing of the capability of applications to
                                            failover to alternate data centers as part of the periodic Data Backup and
                                            BCP testing program.
                                        </li>
                                        <li className="listitem">Duly Board approved BCP Plan for reviewing and ensuring
                                            regular oversight by the Board every year.
                                        </li>
                                        <li className="listitem">Ensure consistency and adequacy in filling regulatory
                                            returns to RBI (COSMOS Returns).
                                        </li>
                                        <li className="listitem">Maintaining System generated reports for the Top
                                            Management summarizing financial position of the organization, including
                                            operating and non-operating revenues and expenses, cost of funds, etc.
                                        </li>
                                        <li className="listitem"> Implement an Information Security Management System
                                            (ISMS) and ensure it is maintained, continually improved, and supported with
                                            adequate resources to achieve the objectives set in this Policy Statement.
                                        </li>
                                    </ul>
                                </p>
                                <p>Our approach to achieving these objectives is to enhance information security through
                                    investment in technology, processes, and employee skills. This will improve the way
                                    we both manage our business and deliver services to our customers. </p>
                                <p className="mgt-5">This policy statement shall be easily accessible to all Revfin
                                    staff. It is also available for public viewing on our website https://revfin.in/ .
                                    Each member of staff is asked to take particular care in their approach to security
                                    and to accept the important role they play in maintaining an effective information
                                    security program throughout Revfin.</p>
                                <p>Effective: 23rd day of December 2021</p>
                            </div>
                            <div className="mgt-5 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <br/>
                                <p style={{'margin-bottom': '0px'}}><b>Sameer Aggarwal</b></p>
                                <p>Founder & Chief Executive Officer, Revfin</p>
                            </div>
                        </div>
                    </div>

                </section>


            </div>
        )
    }
}


export default ISpolicystatement



// WEBPACK FOOTER //
// ./src/components/ISpolicystatement.js